import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import CogIcon from "../../common/icons/cog.svg";
import {
  BackgroundImageContainer,
  ContentContainer,
  MaintenanceHeader,
  MaintenanceInfo,
  PageContainer,
} from "./styled";

export const MaintenancePage = () => {
  const { t } = useTranslation();
  const [entry] = performance.getEntriesByType("navigation");

  if (entry.type === "reload") {
    window.location.href = "/home";
  }

  return (
    <PageContainer>
      <BackgroundImageContainer
        component="img"
        src={process.env.PUBLIC_URL + "/assets/login_bg.png"}
      />
      <ContentContainer>
        <Box>
          <img src={CogIcon} alt="maintenance icon" key="maintenance-icon" />
          <MaintenanceHeader>
            {t("maintenance:scheduled_maintenance_in_progress")}
          </MaintenanceHeader>
          <MaintenanceInfo variant="header">
            {t("maintenance:scheduled_maintenance_in_progress_message")}
          </MaintenanceInfo>
        </Box>
      </ContentContainer>
    </PageContainer>
  );
};
